<template>
  <div class="ine-form__submit-btn-wrapper">
    <button
      v-if="!isLoading"
      class="btn btn--primary"
      :class="[{ 'btn--light': !extraButtonClasses }, extraButtonClasses]"
      type="submit"
      :disabled="disabled"
      formnovalidate
    >
      <component :is="svgIcon" v-if="isSvgIcon" />
      <span v-else-if="iconName" class="material-icons">{{ iconName }}</span>
      {{ title }}
    </button>
    <ActionLoader
      v-else
      loaderClass="ine-form__loading-spinner"
      name="ball-clip-rotate"
    />
  </div>
</template>

<script>
import ActionLoader from '@/components/shared/ActionLoader.vue'
import UserIcon from '@/assets/icons/fill/user.svg'
import LockIcon from '@/assets/icons/fill/lock.svg'

const ICONS_MAPPING = {
  person: UserIcon,
  lock: LockIcon,
}

export default {
  name: 'SubmitBtn',
  components: {
    ActionLoader,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    iconName: {
      type: String,
      required: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
    },
    extraButtonClasses: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    isSvgIcon() {
      return !!ICONS_MAPPING[this.iconName]
    },
    svgIcon() {
      return ICONS_MAPPING[this.iconName]
    },
  },
}
</script>
